import Vue from 'vue'
import {
  Button,
  TabPane,
  Tabs,
  Switch,
  Upload,
  Dialog,
  MessageBox,
  Message,
  Input,
  DatePicker,
  Tooltip,
  Table,
  TableColumn,
  Tag,
  Select,
  Option,
  Pagination,
  Loading,
  scrollbar
} from 'element-ui'

Vue.use(Button)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Switch)
Vue.use(Upload)
Vue.use(Dialog)
Vue.use(Input)
Vue.use(DatePicker)
Vue.use(Tooltip)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Tag)
Vue.use(Select)
Vue.use(Option)
Vue.use(Pagination)
Vue.use(Loading.directive)
Vue.use(scrollbar)

Vue.prototype.$msgbox = MessageBox
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$message = Message
Vue.prototype.$loading = Loading.service